import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';

export const EventTileSkeleton = () => {
  return (
    <div className='event-tile'>
      <button className='event-tile-button'>
        <Skeleton variant='rectangular' width={300} sx={{ height: '200px', margin: '2px 0', borderRadius: '4px' }} />
        <div className='event-info'>
          <div className='location'>
            <Skeleton variant='text' width={80} sx={{ height: '18px', margin: '2px 0' }} />
          </div>
          <div className='time'>
            <Skeleton variant='text' width={120} sx={{ height: '18px', margin: '2px 0' }} />
          </div>
          <div className='event-title'>
            <Skeleton variant='text' width={200} sx={{ height: '18px', margin: '2px 0' }} />
          </div>
        </div>
      </button>
    </div>
  );
};
